import axios from 'axios';
import Cookies from 'js-cookie';
import IMask from "imask";

export default class Forms {
    constructor() {
        this.cpfCnpjField = document.querySelectorAll(".cpfCnpjMask");
        this.phoneField = document.querySelectorAll(".telMask");
        this.dateField = document.querySelectorAll(".dateMask");
    }

    static wrongMessages() {
        let mensagens = {
                messages: {
                    missingValue: {
                        checkbox: "Este campo Ã© obrigatÃ³rio.",
                        radio: "Por favor selecione um valor.",
                        select: "Por favor selecione um valor.",
                        "select-multiple":
                            "Por favor selecione pelo menos um valor.",
                        default: "Por favor preencha este campo",
                    },
                    patternMismatch: {
                        email: "Insira um endereÃ§o de e-mail corporativo vÃ¡lido.",
                        url: "Informe uma url.",
                        number: "Informe o telefone",
                        date: "Por favor utilizar o formato DD/MM/YYYY",
                        default: "Por favor, preencha o campo com conteÃºdo vÃ¡lido.",
                    },
                    outOfRange: {
                        over: "Selecione um valor que nÃ£o seja superior a {max}.",
                        under: "Selecione um valor que nÃ£o seja inferior a {min}.",
                    },
                    wrongLength: {
                        over: "Reduza este texto para nÃ£o mais que {maxLength} caracteres. VocÃª estÃ¡ usando atualmente {length} caracteres.",
                        under: "Por favor, estenda este texto para {minLength} caracteres ou mais. VocÃª estÃ¡ usando atualmente {length} caracteres.",
                    },
                },
            };
        return mensagens;
    }

    static masks(phoneFields, dateFields, cpfCnpjFields, type) {
        if (phoneFields) {
            phoneFields.forEach(field => {
                IMask(field, {
                    mask: "(00) 00000-0000",
                });
            });
        }

        if (dateFields) {
            dateFields.forEach(field => {
                IMask(field, {
                    mask: Date,
                    pattern: "d/`m/`Y",
                    blocks: {
                        d: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 31,
                        },
                        m: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 12,
                        },
                        Y: {
                            mask: IMask.MaskedRange,
                            from: 1900,
                            to: 2090,
                        },
                    },
                });
            });
        }

        if (cpfCnpjFields) {
            cpfCnpjFields.forEach(field => {
                if (field.inputMask) {
                    field.inputMask.destroy();
                }
                if (type === 'CPF') {
                    field.inputMask = IMask(field, {
                        mask: "000.000.000-00",
                    });
                } else {
                    field.inputMask = IMask(field, {
                        mask: "00.000.000/0000-00"
                    });
                }
            });
        }
    }

    static getCrmPayload(formData, camposAdicionais = {}) {
        const payload = {};

        for (const [key, value] of formData.entries()) {
            payload[key] = value;
        }

        payload.modulo = payload.modulo || 'gestor';
        payload.origem = payload.origem || 'SI';
        payload.telefone_ddi = payload.telefone_ddi || '+55';
        payload.permitir_alteracao = true;
        payload.converter = true;
        payload.reativar_lead = true;

        if (!payload.conversao && camposAdicionais.formulario) {
            payload.conversao = camposAdicionais.formulario;
        }

        if (camposAdicionais.tipoInteracao) {
            payload.interacoes = [{
                tipo: camposAdicionais.tipoInteracao,
                descricao: camposAdicionais.mensagem || camposAdicionais.formulario || 'Lead cadastrado pelo site.',
            }];
        }

        payload.campos_adicionais = {
            ...camposAdicionais,
            utm_source: Cookies.get('cflutmsource') || '',
            utm_medium: Cookies.get('cflutmmedium') || '',
            utm_campaign: Cookies.get('cflutmcampaign') || '',
        };

        return payload;
    }

    static sendLeadToCrm(formData, camposAdicionais = {}) {
        return axios({
            method: "post",
            url: `${window.location.origin}/email/cvcrm_lead.php`,
            data: Forms.getCrmPayload(formData, camposAdicionais),
            headers: {"Content-Type": "application/json"}
        }).then((response) => {
            console.info('[CVCRM] Lead enviado com sucesso', response.data);
            return response;
        }).catch((error) => {
            if (error.response) {
                console.error('[CVCRM] Erro ao enviar lead', {
                    status: error.response.status,
                    data: error.response.data,
                });
            } else {
                console.error('[CVCRM] Erro ao enviar lead', error);
            }

            throw error;
        });
    }

    static getCrmResponseMessage(response) {
        const data = response && response.data ? response.data : {};
        const leadData = data.data || data;

        return leadData.mensagem || data.message || 'Lead integrado ao CVCRM.';
    }

    static getCrmErrorMessage(error) {
        const responseData = error && error.response ? error.response.data : null;

        if (responseData) {
            const leadData = responseData.data || {};
            return leadData.mensagem || responseData.message || 'Erro ao integrar lead ao CVCRM.';
        }

        return 'Erro ao integrar lead ao CVCRM.';
    }
}
